<span class="header__title">{{ title() }}</span>

<div class="header__actions" layout layout-align-items-center (click)="$event.stopPropagation()">
  <rt-icon-button
    variant="primary"
    size="small"
    [iconName]="isExpanded() ? 'minimize' : 'minimize-reversed'"
    [rtTooltip]="
      (isExpanded()
        ? 'app.evaluation_panel.header.tooltip_minimize'
        : 'app.evaluation_panel.header.tooltip_expand'
      ) | translate
    "
    rtTooltipPosition="above"
    (click)="expand.emit()"
  />
  <rt-icon-button
    variant="primary"
    size="small"
    [iconName]="isFullScreenMode() ? 'fullscreen-exit' : 'fullscreen'"
    [rtTooltip]="'app.evaluation_panel.header.tooltip_fullscreen' | translate"
    rtTooltipPosition="above"
    (click)="fullscreen.emit()"
  />
  <rt-icon-button
    variant="primary"
    size="small"
    iconName="close"
    [rtTooltip]="'app.evaluation_panel.header.tooltip_close' | translate"
    rtTooltipPosition="above"
    (click)="close.emit()"
  />
</div>
